import React, { FunctionComponent, ReactNode, useMemo } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

import useInternalLink from '../../../../InternalLinkProvider/useInternalLink';
import Link from '../../../../Link';

export type InternalLinkProps = {
  children?: ReactNode;
  mark?: {
    blank?: boolean;
    reference?: {
      _ref?: string;
    };
  };
};

const InternalLink: FunctionComponent<InternalLinkProps> = (props) => {
  const { children, mark } = props;
  const { fonts } = useTheme();

  const target = useMemo(() => {
    if (mark?.blank) {
      return '_blank';
    }
    return undefined;
  }, [mark]);

  const href = useInternalLink(mark?.reference?._ref) || '#';

  return (
    <Text<any>
      css={{ fontSize: fonts.messageExtraSmall.fontSize }}
      as={Link}
      to={href}
      target={target}
      variant="link"
    >
      {children}
    </Text>
  );
};

const internalLinkRenderer = (props: InternalLinkProps) => {
  return <InternalLink {...props} />;
};

export default internalLinkRenderer;
